import sdkProvider from "../helpers/sdk-provider";

export const setCustomerConsent = async (optConsent) => {
  const loyalty = await sdkProvider("loyalty");
  return await loyalty.setCustomerConsent(optConsent);
};

export const getCustomerDetails = async () => {
  const loyalty = await sdkProvider("loyalty");
  return await loyalty.getCustomerDetails();
};

export const getCustomerTierId = async () => {
  const loyalty = await sdkProvider("loyalty");
  return await loyalty.getCustomerTierId();
};

export const getIsLoyaltyAvailable = async () => {
  const loyalty = await sdkProvider("loyalty");
  return await loyalty.isLoyaltyAvailable();
};

export const getConfig = async () => {
  const loyalty = await sdkProvider("loyalty");
  return await loyalty.getConfig();
};

export const isBenefitAvailableForTier = async (
  currentTierId,
  loyaltyBenefitType
) => {
  const loyalty = await sdkProvider("loyalty");
  return await loyalty.isBenefitAvailableForTier(
    currentTierId,
    loyaltyBenefitType
  );
};
